require('./retailDeliveryInfoBoxAside.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const DateHelper = require('utilities/dateHelper');

//@constants
const {
    retailLoanCommons: { FORMAT_DATE_DELIVERY_MONTH },
} = require('../../../../loansConstants/index');

const buildDateOrPickUpOption = (labels, isAddress) => {
    const deliveryDate = DateHelper.formatDate(labels.deliveryDate, FORMAT_DATE_DELIVERY_MONTH);
    let textDeliveryInfo = labels.concessionaire;
    let contentValueDate;

    if (isAddress) {
        textDeliveryInfo = labels.dateEstimatedDelivery2;
        contentValueDate = (<span className="retail-delivery-info-box-aside__content-value-date">{deliveryDate}</span>);
    }

    return (
        <React.Fragment>
            <span className="retail-delivery-info-box-aside__content-pick-up-or-date">
                {textDeliveryInfo}
            </span>
            {contentValueDate}
        </React.Fragment>
    );
}

const RetailDeliveryInfoBoxAside = ({ labels, isAddress }) => {

    let boxIconSend = 'icon-locacion';
    let sendType = labels.pickUpIn;

    if (isAddress) {
        boxIconSend = 'icon-envio_rapido retail-delivery-info-box-aside__send-type--icon-send';
        sendType = labels.dateEstimatedDelivery1;
    }

    return (
        <React.Fragment>
            <div className="col-md-12 col-lg-12 retail-delivery-info-box-aside">
                <div className="retail-delivery-info-box-aside__content-text" >
                    <div className="retail-delivery-info-box-aside__content-product-cost">
                        <i className={`retail-delivery-info-box-aside__send-type retail-delivery-info-box-aside__send-type--icon ${boxIconSend}`} />
                        <div className="retail-delivery-info-box-aside__send-type">
                            {sendType}
                        </div>
                    </div>
                    {buildDateOrPickUpOption(labels, isAddress)}
                </div>
            </div>
        </React.Fragment>
    )
}

RetailDeliveryInfoBoxAside.propTypes = {
    isAddress: PropTypes.bool.isRequired,
    labels: PropTypes.object.isRequired,
};

export { RetailDeliveryInfoBoxAside };
